import React from "react";
import { ArrowRight } from "lucide-react"; // npm install lucide-react
import { useNavigate } from "react-router-dom";

const categories = [
  "Our Product on Automotive  :   SUSPA, UCAL, RANE, DAIMLER, PHA",
  "Product on Agri Field :  GREAVES, YANMAR, SOUTHERN AGRO",
  "Product on Aeronautical  Field :  YUKEN",
  "Product on lifters :  SUSPA",
  "Customer PPM on our Product :   0 - 5",
  "Product on In-house PPM :  <300",
  "Certified as IATF 16949: 2016 by TUV Stud.",
  "Certified as MACE GREEN VENDOR.",
];

const infoCards = [
  {
    title: "Who we are & what we do",
    description:
      "Discover our legacy, values, and the work in the fastener manufacturing industry.",
    path: "/about",
  },
  {
    title: "Know about our Products",
    description:
      "From design to delivery — we manufacture with precision to meet your exact product needs.",
    path: "/products",
  },
  {
    title: "Drop us your message!",
    description:
      "Have a requirement or a question? Our team is ready to help — let’s get started.",
    path: "/contact",
  },
];

const InfoCards = () => {
  const navigate = useNavigate();

  return (
    <section>
      {/* Green Category Strip with Marquee */}
      <div className="bg-blue-100 py-4 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee">
          {/* Duplicate list twice for infinite scroll */}
          {[...categories, ...categories].map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-2 px-6 text-black font-medium"
            >
              {idx % categories.length !== 0 && (
                <span className="text-lg">✦</span>
              )}
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Black Info Section */}
      <div className="bg-[#000615] py-[100px] px-[25px]">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 text-white px-6">
          {infoCards.map((card, idx) => (
            <div key={idx} className="space-y-4">
              <h3 className="text-[24px] font-semibold">{card.title}</h3>
              <p className="text-[#9ca3af] text-[16px] font-normal">
                {card.description}
              </p>
              <button
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  navigate(card.path);
                }}
                className="inline-flex items-center gap-2 text-[16px] font-medium hover:underline"
              >
                Learn more <ArrowRight size={16} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoCards;
